import * as React from 'react'
import { getSearchboxStyles as getStyles } from './styles'

import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/material/styles'

export const Searchbox: React.FC<{
  filter: string
  onChangeFilter: (e: React.ChangeEvent<HTMLInputElement>) => void
  onClearFilter: () => void
}> = (props) => {
  const { filter, onChangeFilter, onClearFilter } = props
  const theme = useTheme()
  const { textfield } = getStyles(theme)

  return (
    <TextField
      value={filter}
      onChange={onChangeFilter}
      placeholder="Search"
      size="small"
      fullWidth
      sx={textfield}
      InputProps={{
        endAdornment: filter !== '' && (
          <InputAdornment position="end">
            <IconButton
              size="small"
              edge="end"
              onClick={onClearFilter}
              data-test-id="columnsSelectorSearchClearBtn"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}
